/**
 * Results Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import AppConfig from "../../../constants/AppConfig";
import {store} from "../../store";

// States
const state = {
    results: [],
    result: {}
};

// Getters
const getters = {
    results: state => {
        return state.results
    },

    result: state => {
        return state.result
    }
};

// Actions
const actions = {
    getLabResults(context, payload) {
        function successCallback(response) {
            context.commit('getResultsHandler', { results: response.data.resultats });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Result.Lab.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getImageryResults(context, payload) {
        function successCallback(response) {
            context.commit('getResultsHandler', { results: response.data.resultats });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Result.Imagery.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getLabResult(context, payload) {
        function successCallback(response) {
            context.commit('getResultHandler', { result: response.data.resultat });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Result.Lab.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getImageryResult(context, payload) {
        function successCallback(response) {
            context.commit('getResultHandler', { result: response.data.resultat });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Result.Imagery.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createLabResult(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'lab-result' , params: { result: response.data.resultat.slug } });
        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        let url = AppConfig.apiUrl + apiModel.Result.Lab.Create.url;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);

        //makeApiRequest(payload.args, apiModel.Result.Lab.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createImageryResult(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'imagery-result', params: { result: response.data.resultat.slug } });
        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        let url = AppConfig.apiUrl + apiModel.Result.Imagery.Create.url;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);

        //makeApiRequest(payload.args, apiModel.Result.Imagery.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateLabResult(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            // router.push({ name: 'lab-results' });
            store.dispatch('findAndRemove', {name: 'lab-result' });

            router.push({ name: 'lab-result', params: { result: response.data.resultat.slug } });
            // router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.resultat.dossier.slug } }).href) +"#resultatLabo");
        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        let url = AppConfig.apiUrl + apiModel.Result.Lab.Create.url + '/' + payload.result;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);

        //makeApiRequest(payload.args, apiModel.Result.Lab.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateImageryResult(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            // router.push({ name: 'imagery-results' });
            store.dispatch('findAndRemove', {name: 'imagery-result' });
            router.push({ name: 'imagery-result', params: { result: response.data.resultat.slug } });
            // router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.resultat.dossier.slug } }).href) +"#resultatImagerie");
        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        let url = AppConfig.apiUrl + apiModel.Result.Imagery.Create.url + '/' + payload.result;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);

        //makeApiRequest(payload.args, apiModel.Result.Imagery.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteLabResult(context, payload) {
        function successCallback(response) {
            context.commit('deleteResultHandler', { index: payload.index, successMessage: payload.successMessage });
            router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.resultat.dossier.slug } }).href) +"#resultatLabo");


        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Result.Lab.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteImageryResult(context, payload) {
        function successCallback(response) {
            context.commit('deleteResultHandler', { index: payload.index, successMessage: payload.successMessage });
            router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.resultat.dossier.slug } }).href) +"#resultatImagerie");


        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Result.Imagery.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    archieveLaboResult(context, payload) {
        function successCallback(response) {
            context.commit('archieveLaboResultHandler', { index: payload.index, successMessage: payload.successMessage });

            context.commit('getResultHandler', { result: response.data.resultat });
            // router.push({ name: 'lab-results' });

            router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.resultat.dossier.slug } }).href) +"#resultatLabo");

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Result.Lab.Archieve, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    transmitLaboResult(context, payload) {
        function successCallback(response) {
            context.commit('transmitLaboResultHandler', { index: payload.index, successMessage: payload.successMessage });

            context.commit('getResultHandler', { result: response.data.resultat });
            // router.push({ name: 'lab-results' });

            router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.resultat.dossier.slug } }).href) +"#resultatLabo");

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Result.Lab.Transmit, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    archieveImagerieResult(context, payload) {
        function successCallback(response) {
            context.commit('archieveImagerieResultHandler', { index: payload.index, successMessage: payload.successMessage });

            context.commit('getResultHandler', { result: response.data.resultat });

            // router.push({ name: 'imagery-results' });
            router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.resultat.dossier.slug } }).href) +"#resultatImagerie");

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Result.Imagery.Archieve, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    transmitImagerieResult(context, payload) {
        function successCallback(response) {
            context.commit('transmitImagerieResultHandler', { index: payload.index, successMessage: payload.successMessage });

            context.commit('getResultHandler', { result: response.data.resultat });
            // router.push({ name: 'imagery-results' });

            router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.resultat.dossier.slug } }).href) +"#resultatImagerie");

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args,  apiModel.Result.Imagery.Transmit, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getResultsHandler(state, { results }) {
        // Update results state
        state.results = results;
    },

    getResultHandler(state, { result }) {
        // Update result state
        state.result = result;
    },

    deleteResultHandler(state, { index, successMessage }) {
        //
        // let i = state.results.findIndex(result => result.slug === index);
        //
        // if (~i) {
        //     state.results.splice(i, 1);

            // router.push({ name: 'results' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        // }
    },

    archieveLaboResultHandler(state, { index, successMessage }) {

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    transmitLaboResultHandler(state, { index, successMessage }) {

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    archieveImagerieResultHandler(state, { index, successMessage }) {
        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    transmitImagerieResultHandler(state, { index, successMessage }) {
        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}